import { Component, Input, Output, EventEmitter } from "@angular/core";
import { EcertBaseBlockComponent } from "../ecertnl-base-block/ecertnl-base-block.component";

@Component({
  selector: "ecert-textinput",
  templateUrl: "./ecertnl-input.component.html",
  styleUrls: ["./ecertnl-input.component.css"],
  standalone: false,
})
export class EcertInputComponent extends EcertBaseBlockComponent {
  @Input() id: any;
  @Input() type = "text";
  @Input() error: boolean;
  @Input() foutmelding: string;
  @Input() pattern: any;
  @Input() patternFoutmelding: any = null;
  @Input() clear_button: boolean = false;

  foutmeldingRegel2: string;
  foutmeldingRegel3: string;

  leegFoutmelding() {
    this.foutmelding = "";
    this.foutmeldingRegel2 = "";
    this.foutmeldingRegel3 = "";
    this.error = false;
  }

  onBlur(event) {
    this.checkValue(event.target.value);
    this.onChange.emit();
  }

  checkValue(value) {
    let formatValue = value;

    // Geef een foutmelding bij het certificaat-nummer als deze leeg is.
    if (
      formatValue != null &&
      formatValue == "" &&
      this.id == "certificaat_nummer"
    ) {
      this.error = true;
      return;
    }

    // Bepaal de waarde zonder koppeltekens
    let val = value.replace(/-/g, "");

    // Toon een foutmelding als de ingevulde waarde niet voldoet aan het pattern
    if (
      value != null &&
      value.length > 0 &&
      this.pattern != null &&
      !this.pattern.test(val)
    ) {
      this.error = true;
    } else {
      this.error = false;
    }

    // Verwijderen en opnieuw toevoegen van koppeltekens bij het verificatie-nummer
    if (formatValue != null && formatValue.length > 0) {
      if (this.id == "verificatie_nummer") {
        formatValue = formatValue.replace(/-/g, "");
        if (formatValue.length >= 13) {
          formatValue =
            formatValue.substr(0, 12) + "-" + formatValue.substr(12);
        }
        if (formatValue.length >= 9) {
          formatValue = formatValue.substr(0, 8) + "-" + formatValue.substr(8);
        }
        if (formatValue.length >= 5) {
          formatValue = formatValue.substr(0, 4) + "-" + formatValue.substr(4);
        }
      }
      this.ref_object[this.property] = formatValue;
    }
  }

  hasErrors() {
    return this.error;
  }

  setError(foutmelding) {
    this.foutmelding = foutmelding;
    this.error = true;
  }

  reset() {
    this.onChange.emit("");
  }
}
